import Favorite from './Favorite.vue';

export default Favorite;



// WEBPACK FOOTER //
// ./src/pages/profile/views/favorite/index.ts